import HomeFieldConfig from 'app/views/home/webgl/particles/config/HomeFieldConfig';
import { HomeParticle } from 'app/views/home/webgl/particles/fields/HomeParticle';

export default {
	pools: {
		systems: []
	},

	setPool(type: string, pool: Array<HomeParticle> = null) {
		if (pool) {
			this.pools[type] = pool;
			return;
		}

		this.pools[type] = HomeFieldConfig.getParticlePool(this._homeField.particles as Array<HomeParticle>, type);
	},

	reset(poolType: string) {
		for (let i = 0; i < this.pools[poolType].length; i++) {
			this.free(this.pools[poolType][i]);
		}
	},

	get(poolType: string = 'systems'): HomeParticle {
		for (let i = 0; i < this.pools[poolType].length; i++) {
			if (!this.pools[poolType][i].pooled) {
				this.pools[poolType][i].pooled = true;
				return this.pools[poolType][i];
			}
		}
	},

	free(particle: HomeParticle) {
		particle.pooled = false;
	}
};
